// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fa-solid[data-v-b5b81e4a]{color:#009fe3}.breakdown-content[data-v-b5b81e4a]{z-index:9999;width:200px;background-color:#fff;box-shadow:0 4px 10px rgba(0,0,0,.18);border-radius:4px;padding:14px}.breakdown-content .vat-item[data-v-b5b81e4a]{width:100%}.breakdown-content .vat-item__title[data-v-b5b81e4a]{color:#969696;margin-bottom:10px;font-size:14px;text-transform:uppercase}.breakdown-content .vat-item__total[data-v-b5b81e4a]{display:flex;justify-content:space-between}", ""]);
// Exports
module.exports = exports;
